import { render, staticRenderFns } from "./UserGroupSelect.vue?vue&type=template&id=054f6e98&scoped=true&"
import script from "./UserGroupSelect.vue?vue&type=script&lang=js&"
export * from "./UserGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupSelect.vue?vue&type=style&index=0&id=054f6e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f6e98",
  null
  
)

component.options.__file = "UserGroupSelect.vue"
export default component.exports